import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'patientIds' })
export class PatientIdsPipe implements PipeTransform {
  transform(patients: any[]): string {
    return patients?.map(p => p.id).join(', ') || '';
  }
}
